/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from './cardtoggles_styles';



/* ========== ~~~~~~~~~~ CARD TOGGLES ~~~~~~~~~~ ========== */
const CardToggles = injectSheet(styles)((props) => {
    return (
        <div className={`cardtoggles ${props.classes.cardtoggles}`}>
            {props.children}
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CardToggles;
